import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useState, useCallback, useContext } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { URLS } from '@wix/da-url';
import { BiData, BiContextProvidedValue } from '@wix/da-bi/pkg/events';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import CoreIcon from '@wix/da-ds/pkg/Icons/24x24/Core';
import EyeIcon from '@wix/da-ds/pkg/Icons/Eye';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import InfoBlock from '@wix/da-ds/pkg/InfoBlock';
import PreviewModeBar from '@wix/da-ds/pkg/PreviewModeBar';
import BuyCoreButton from '../../../Button/BuyCoreButton';
import CoreExclusiveFeature from '../../../indicators/CoreExclusiveFeature/CoreExclusiveFeature';
import s from './WidgetPaywall.scss';
var WidgetPaywallView;
(function(WidgetPaywallView) {
    WidgetPaywallView["LOCKED"] = "locked";
    WidgetPaywallView["PREVIEW"] = "preview";
})(WidgetPaywallView || (WidgetPaywallView = {}));
export const WidgetPaywall = (_param)=>{
    var { className, lockedClassName, children, previewReferral = ReferralType.WIDGET_PAYWALL_PREVIEW, lockedReferral = ReferralType.WIDGET_PAYWALL_OVERLAY } = _param, restProps = _object_without_properties(_param, [
        "className",
        "lockedClassName",
        "children",
        "previewReferral",
        "lockedReferral"
    ]);
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const [activeView, setActiveView] = useState("locked");
    const showPreview = useCallback(()=>setActiveView("preview"), []);
    const showLocked = useCallback(()=>setActiveView("locked"), []);
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "WidgetPaywall"
    }, /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], activeView === "preview" && s['root-preview'], className)
    }, activeView === "locked" && /*#__PURE__*/ React.createElement("div", {
        className: s['overlay']
    }, /*#__PURE__*/ React.createElement(InfoBlock, _object_spread({
        className: c(s['locked'], lockedClassName),
        backgroundType: "none",
        title: t('widgets.common.paywall.widgetPreview.title'),
        subtitle: t('widgets.common.paywall.widgetPreview.subtitle'),
        buttonAlignment: "vertical",
        illustration: /*#__PURE__*/ React.createElement(CoreExclusiveFeature, {
            withoutBuyCTA: true
        }),
        customButton: /*#__PURE__*/ React.createElement(BuyCoreButton, {
            size: "large",
            biData: {
                referral_info: lockedReferral
            }
        }, t('widgets.common.paywall.widgetPreview.button.upgrade')),
        customSecondaryButton: /*#__PURE__*/ React.createElement(GhostButton, {
            size: "medium",
            variant: "main",
            icon: EyeIcon,
            onClick: showPreview,
            biData: BiData({
                evid: 268,
                widgetname: BiContextProvidedValue
            })
        }, t('widgets.common.paywall.widgetPreview.button.preview'))
    }, restProps))), activeView === "preview" && /*#__PURE__*/ React.createElement("div", {
        className: c(s['overlay'], s['preview-overlay'])
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['preview']
    }, /*#__PURE__*/ React.createElement(PreviewModeBar, {
        onClose: showLocked,
        messageBeforeIcon: t(isMobile ? 'widgets.common.paywall.widgetPreview.snackbar.pushThisLive.mobile' : 'widgets.common.paywall.widgetPreview.snackbar.pushThisLive'),
        icon: /*#__PURE__*/ React.createElement(CoreIcon, {
            size: IconSize.SMALL,
            disableDefaultColors: true
        }),
        ctaHref: URLS.CORE_MEMBERSHIP,
        ctaBiData: BiData({
            evid: 375,
            referral_info: previewReferral
        }),
        ctaLabel: t('widgets.common.paywall.widgetPreview.snackbar.upgradeToPublish')
    }))), children));
};
WidgetPaywall.displayName = 'WidgetPaywall';
export default WidgetPaywall;
